import { GuardedComponent } from '../components/guarded-component';
import CocPage from '../features/coc/coc.page';
import { UserPermissionName } from '../models/user-permission-name';

export const CocRoute = {
  path: '/coc',
  name: 'COC',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_COC_REPORT]} showPermissionError>
          <CocPage />
        </GuardedComponent>
      ),
    },
  ],
};
